// extracted by mini-css-extract-plugin
module.exports = {"compound_dialog":"styles_compound_dialog__3F-Fl","put_modal_container":"styles_put_modal_container__XN3T7","btns":"styles_btns__2UdQT"};